function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  "data-name": "Layer 2"
}, React.createElement("path", {
  d: "M42.9 60a38.23 38.23 0 01-7.47-23.22L35.34 0H16.91L17 36.76A38.23 38.23 0 019.51 60C2.28 70.07 0 78.54 0 94.71v94.6h52.41v-94.6c0-16.17-2.28-24.64-9.51-34.71zM31.41 4l.09 32.59H20.91l-.06-32.66zm13.77 147.71H7.5V103h37.68z",
  fill: "currentColor",
  "data-name": "Layer 1"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 52.41 189.31"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/wine-bottle.svg";
export { SvgComponent as ReactComponent };